import { LoaderFunction } from "react-router-dom";
import { medicationsApi } from "src/api/services/medicationsApi";
import { store } from "src/api/store";

export const medicationLoader: LoaderFunction = ({ params }) => {
  if (params.medicationId != null) {
    return store
      .dispatch(
        medicationsApi.endpoints.getMedication.initiate(
          Number(params.medicationId),
        ),
      )
      .unwrap();
  }
};
